import styles from "./BoletimSubsection.module.css";

function BoletimSubsection({ children, subtitle }) {
	return (
		<div className={styles.container}>
			<div className={styles.head}>
				<div className={styles.subtitle}>{subtitle}</div>
			</div>
			{children}
		</div>
	);
}

export default BoletimSubsection;
